import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: "e16d40cf-2301-48a8-b6f4-f1d6715b0b07", // ui dev
      authority: "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d", // dev
      redirectUri: '/'
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false
    },
    interactionType: 'Redirect',
    backendApiScope: 'api://asa-api-access-auth.pp.gm.com/user_impersonation'
  },
  apiConfig: {
    // Deployed DEV environment (GitHub Actions uses `--configuration development`).
    // Use an absolute backend URL; there is no Angular dev-server proxy in Azure.
    baseUrl: 'https://asa-back-dev.musea2.azure.ext.gm.com',
    endpoints: {
      inventory: '/inventory',
      compare: '/compare',
      tree: '/tree',
      changeHistory: '/change-history'
    }
  },
  peopleSync: {
    url: 'https://graph.microsoft.com/v1.0/users',
    endpoints: {
      gmid: '/gmid',
      email: '/email',
      gmin: '/gmin'
    }
  },
  features: {
    enableDebugMode: true,
    enableConsoleLogging: true
  }
};